<template>
    <div>
        <div class="line-item-group">
            <div class="line-item" data-qa="totalDue">
                <div class="line-item__header">
                    <h3>Subtotal</h3>
                    <p data-qa="total-due-total">{{ $store.getters.currencyPrefix }}{{ subtotalInvoiceDue }}</p>
                </div>
            </div>
            <div class="line-item" data-qa="totalDue" v-if="!!appliedPromos">
                <div class="line-item__header">
                    <h3 class="text-green-accessible">Promotions</h3>
                    <p class="text-green-accessible" data-qa="total-due-total">{{ appliedPromos }}</p>
                </div>
            </div>
            <div class="line-item" v-if="$store.getters.tax > 0" data-qa="tax">
                <div class="line-item__header">
                    <h3>Tax</h3>
                    <p data-qa="tax-total"><span v-text="$store.getters.currencyPrefix"></span>{{ priceFormat($store.getters.tax) }}</p>
                </div>
            </div>
            <div class="line-item" data-qa="totalDue">
                <div class="line-item__header">
                    <h3>Total</h3>
                    <p data-qa="total-due-total">{{ $store.getters.currencyPrefix }}{{ totalInvoiceDue }}</p>
                </div>
            </div>
            <div class="line-item" data-qa="totalDue" v-if="$store.getters.cartInfo.installments.enabled">
                <div class="line-item__header">
                    <h3>Installments</h3>
                    <p data-qa="total-due-total">{{ $store.getters.currencyPrefix }}{{ chargedTodayTotal }} x {{ $store.getters.cartInfo.installments.count }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as Analytics from '@/Util/reporting.js';

import BillingToggle from '@/BuyNow/Components/BillingToggle.vue';
import Dropdown from '@/BuyNow/Components/inputs/Dropdown.vue';
import CheckBox from '@/BuyNow/Components/inputs/CheckBox.vue';
import SupportLink from '@/BuyNow/Components/SupportLink.vue';
import KeapButton from '@/Components/KeapButton.vue';
import LineItem from '@/BuyNow/Components/Summary/LineItem.vue';
import {priceFormat, pluralize} from '@/Util/helpers.js';

export default {
    components: {
        BillingToggle,
        Dropdown,
        KeapButton,
        SupportLink,
        CheckBox,
        LineItem,
    },
    props: {
        hasBillingToggle: {
            type: Boolean,
            default: false,
        },
        hasCurrency: {
            type: Boolean,
            default: false,
        },
        hasCheckout: {
            type: Boolean,
            default: false,
        },
        hasChargeToday: {
            type: Boolean,
            default: false,
        },
        hasLegal: {
            type: Boolean,
            default: false,
        },
        hasSupport: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        priceFormat,
        goToStep(step) {
            if (step === 1) {
                Analytics.pushToDataLayer({
                    event: 'click',
                    attributes: {
                        section: 'Plan Overview',
                        action: 'Click button',
                        event_label: 'Go to payment',
                    },
                });
            }
            this.currentStep = step;
        },
        tempStoreItems(items) {
            items = items.filter(item => {
                if (!!item.metadata.showForCountries) {
                    if (
                        this.currency != 'USD'
                        || !item.metadata.showForCountries.includes(this.country.toLowerCase())
                    ) {
                        return true;
                    }
                }

                return false;
            });

            return items;
        },
        isAttachment(itemId) {
            return !this.$store.state.cartInfo.pricing.plans.find(plan => plan.id === itemId);
        },
        findItem(itemId) {
            let foundItem;
            if (this.isAttachment(itemId)) {
                const attachments = [
                    ...this.$store.getters.selectedPlan.addons,
                    ...this.$store.getters.selectedPlan.charges,
                ];
                foundItem = attachments.find(attachment => attachment.itemId === itemId);
            } else {
                foundItem = this.$store.state.cartInfo.pricing.plans.find(plan => plan.id == itemId);
            }

            return foundItem;
        },
    },
    computed: {
        installmentBreakdown() {
            let countArray = [];
            for (let i = 0; i < this.$store.getters.cartInfo.installments.count; i++) {

                if (i + 1 === this.$store.getters.cartInfo.installments.count) {
                    countArray.push(`and ${i + 1}`);
                } else {
                    countArray.push(i + 1);
                }
            }

            return countArray.join(', ');
        },
        appliedPromos() {
            let total = this.$store.getters.totals.invoiceDiscountTotal.total + this.$store.getters.totals.limitedPeriodDiscountTotal + this.$store.getters.totals.oneTimeDiscountTotal + this.$store.getters.totals.everGreenDiscountTotal;

            if (this.$store.getters.featureFlags?.BN_PULL_TOTALS_FROM_CB_ESTIMATE && this.$store.getters.estimate.discount > 0) {
                total = this.$store.getters.estimate.discount / 100;
            }

            if (total <= 0) {
                return false;
            }

            return `-${this.$store.getters.currencyPrefix}${priceFormat(total)}`;
        },
        canSubmit() {
            return !this.$store.getters.isSoftLoading && this.$store.getters.canSubmit;
        },
        chargedTodayTotal() {
            let total = (this.$store.getters.totals.total - this.$store.getters.totals.invoiceDiscountTotal.total) / (this.$store.getters.cartInfo.installments.count || 1);

            if (this.$store.getters.featureFlags?.BN_PULL_TOTALS_FROM_CB_ESTIMATE) {
                total = this.$store.getters.estimate.total / 100;

                if (this.$store.getters.cartInfo.installments.enabled) {
                    total = total / this.$store.getters.cartInfo.installments.count;
                }
            }

            return total < 0 ? priceFormat(0) : priceFormat(total);
        },
        subtotalInvoiceDue() {
            let total = this.$store.getters.totals.subTotal + this.$store.getters.totals.oneTimeChargesTotal;

            return total < 0 ? priceFormat(0) : priceFormat(total);
        },
        totalInvoiceDue() {
            let total = this.$store.getters.totals.total - this.$store.getters.totals.invoiceDiscountTotal.total;

            if (this.$store.getters.featureFlags?.BN_PULL_TOTALS_FROM_CB_ESTIMATE && this.$store.getters.hasFetchedEstimate) {
                total = this.$store.getters.estimate.total / 100;
            }

            return total < 0 ? priceFormat(0) : priceFormat(total);
        },
        renewalTotal() {
            let total = this.$store.getters.totals.subTotal - this.$store.getters.totals.everGreenDiscountTotal - this.$store.getters.totals.invoiceDiscountTotal.everGreenTotal;

            if (this.$store.getters.featureFlags?.BN_PULL_TOTALS_FROM_CB_ESTIMATE) {
                total = this.$store.getters.estimate?.renewal?.subtotal / 100;
            }

            return total < 0 ? priceFormat(0) : priceFormat(total);
        },
        invoiceCoupons() {
            let coupons = this.$store.getters.invoiceCoupons;

            coupons = coupons.map(coupon => {
                let description = '';
                let calcAmount = 0;

                if (coupon.duration == 'limited_period') {
                    if (coupon.type === 'fixed_amount') {
                        calcAmount = coupon.amount / 100;
                        description = `${this.$store.getters.currencyPrefix}${coupon.amount / 100} off for ${coupon.period} ${pluralize(coupon.periodUnit, coupon.period)}`;
                    }
                    if (coupon.type === 'percentage') {
                        calcAmount = priceFormat(this.$store.getters.totals.subTotal * ((coupon.amount / 100) / 100));
                        description = `${coupon.amount / 100}% off for ${coupon.period} ${pluralize(coupon.periodUnit, coupon.period)}`;
                    }
                }

                if (coupon.duration == 'one_time') {
                    if (coupon.type === 'fixed_amount') {
                        calcAmount = coupon.amount / 100;
                        description = `${this.$store.getters.currencyPrefix}${coupon.amount / 100} off one time`;
                    }

                    if (coupon.type === 'percentage') {
                        calcAmount = priceFormat(this.$store.getters.totals.subTotal * ((coupon.amount / 100) / 100));
                        description = `${coupon.amount / 100}% off one time`;
                    }
                }

                if (coupon.duration == 'forever') {
                    if (coupon.type === 'fixed_amount') {
                        calcAmount = coupon.amount / 100;
                        description = `${this.$store.getters.currencyPrefix}${coupon.amount / 100} off forever`;
                    }

                    if (coupon.type === 'percentage') {
                        calcAmount = priceFormat(this.$store.getters.totals.total * ((coupon.amount / 100) / 100));
                        description = `${coupon.amount / 100}% off forever`;
                    }
                }

                return {
                    ...coupon,
                    description,
                    calcAmount,
                };
            });

            return coupons;
        },
        planItem() {
            const foundItem = {
                ...this.findItem(this.$store.getters.selectedPlanId),
                itemId: this.$store.getters.selectedPlanId,
                selectedQuantity: 1,
            };

            return foundItem;
        },
        addonLineItems() {
            const items = this.$store.state.cartInfo.selectedAddons;
            const fullItems = items.map(item => {
                const foundItem = this.findItem(item.itemId);
                if (!foundItem) {
                    return;
                }
                return {
                    ...foundItem,
                    selectedQuantity: item.quantity,
                };
            }).filter(item => !!item);

            return fullItems.map(item => {
                return {
                    ...item,
                    ...(!item.itemId && {itemId: item.id})
                }
            }).sort((a, b) => {
                return a.metadata?.order - b.metadata?.order;
            });
        },
        chargeLineItems() {
            const items = this.$store.state.cartInfo.selectedCharges;
            const fullItems = items.map(item => {
                const foundItem = this.findItem(item.itemId);
                if (!foundItem) {
                    return;
                }
                return {
                    ...foundItem,
                    selectedQuantity: item.quantity,
                };
            }).filter(item => !!item).map(item => {
                if (item.itemId.toLowerCase().includes('installment-charge')) {
                    item.customDescription = `<p class="text-green-accessible">${this.$store.getters.cartInfo.installments.count} monthly payments</p>`;
                }
                return {
                    ...item,
                    ...(!item.itemId && {itemId: item.id})
                }
            }).sort((a, b) => {
                return a.metadata.order - b.metadata.order;
            });

            return fullItems;
        },
        currencies() {
            return this.$store.getters.allCurrencies;
        },
        country() {
            return this.$store.state.userInfo.country;
        },
        tcAgreement: {
            get() {
                return this.$store.getters.cartInfo.acceptedTc;
            },
            set(value) {
                this.$store.commit('updateCartInfo', { acceptedTc: value })
            }
        },
        tcAgreementValid: {
            get() {
                return this.$store.state.validation.tcAgreement.valid;
            },
            set(value) {
                this.$store.commit('updateValidation', { tcAgreement: { valid: value, message: this.tcAgreementError }})
            }
        },
        tcAgreementError: {
            get() {
                return this.$store.state.validation.tcAgreement.message;
            },
            set(value) {
                this.$store.commit('updateValidation', { tcAgreement: { valid: this.tcAgreementValid, message: value }})
            }
        },
        mbg90Agreement: {
            get() {
                return this.$store.getters.cartInfo.acceptedMbg90;
            },
            set(value) {
                this.$store.commit('updateCartInfo', { acceptedMbg90: value })
            }
        },
        mbg90AgreementValid: {
            get() {
                return this.$store.state.validation.mbg90Agreement.valid;
            },
            set(value) {
                this.$store.commit('updateValidation', { mbg90Agreement: { valid: value, message: this.mbg90AgreementError }})
            }
        },
        mbg90AgreementError: {
            get() {
                return this.$store.state.validation.mbg90Agreement.message;
            },
            set(value) {
                this.$store.commit('updateValidation', { mbg90Agreement: { valid: this.mbg90AgreementValid, message: value }})
            }
        },
        currency: {
            get() {
                return this.$store.getters.selectedCurrency;
            },
            set(value) {
                this.$store.commit('updateUserInfo', { currency: value })
            }
        },
        currentStep: {
            get() {
                return this.$store.getters.currentStep;
            },
            set( step ) {
                this.$store.commit('setCurrentStep', step);
            }
        }
    },
    watch: {
        tcAgreement(newVal, oldVal) {
            if (!newVal) {
                this.tcAgreementValid = false;
            } else {
                this.tcAgreementValid = true;
            }
        },
        mbg90Agreement(newVal, oldVal) {
            if (!newVal) {
                this.mbg90AgreementValid = false;
            } else {
                this.mbg90AgreementValid = true;
            }
        },
        country(newVal) {
            let itemsToStore = this.tempStoreItems([...this.addonLineItems, ...this.chargeLineItems]);

            if (itemsToStore.length <= 0 && this.$store.getters.tempStorage.attachments.length > 0 && (['us', 'ca'].includes(newVal.toLowerCase()) || this.currency === 'USD')) {
                this.$store.getters.tempStorage.attachments.forEach(item => {
                    this.$store.commit('addAttachment', { itemId: item.itemId, quantity: item.quantity });
                });
                this.$store.commit('clearTempAttachmentStorage');
            } else {
                itemsToStore.forEach(item => {
                    this.$store.commit('updateTempAttachmentStorage', {itemId: item.itemId, quantity: item.selectedQuantity});
                    this.$store.commit('removeAttachment', item.itemId);
                });
            }
        },
        currency(newVal) {
            let itemsToStore = this.tempStoreItems([...this.addonLineItems, ...this.chargeLineItems]);

            Analytics.pushToDataLayer({
                event: 'click',
                attributes: {
                    section: 'Plan Overview',
                    action: 'Changed currency',
                    event_label: newVal,
                },
            });

            if (itemsToStore.length <= 0 && this.$store.getters.tempStorage.attachments.length > 0 && newVal == 'USD') {
                this.$store.getters.tempStorage.attachments.forEach(item => {
                    this.$store.commit('addAttachment', { itemId: item.itemId, quantity: item.quantity });
                });
                this.$store.commit('clearTempAttachmentStorage');
            } else {
                itemsToStore.forEach(item => {
                    this.$store.commit('updateTempAttachmentStorage', {itemId: item.itemId, quantity: item.selectedQuantity});
                    this.$store.commit('removeAttachment', item.itemId);
                });
            }
        }
    }
};
</script>

<style lang="postcss" scoped>
.line-item-group {
    @apply space-y-2.5 mb-0;
}
.line-item {
    @apply pb-0;
}
</style>
